import React from 'react'
import Map from '../components/map'

export default () => <Map />
